import { render, staticRenderFns } from "./BindWx.vue?vue&type=template&id=9b326292&scoped=true"
import script from "./BindWx.vue?vue&type=script&lang=js"
export * from "./BindWx.vue?vue&type=script&lang=js"
import style0 from "./BindWx.vue?vue&type=style&index=0&id=9b326292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b326292",
  null
  
)

export default component.exports